import { createActionGroup, emptyProps, props } from '@ngrx/store';

export const loginActions = createActionGroup({
  source: 'Login',
  events: {
    'Username Password Submitted': emptyProps(),
    'Username Password Submitted Success': props<{ authMethod: 'password' }>(),
  },
});
